export default __webpack_public_path__ + "static/media/Logo-single-line.969972e7.svg";